module.exports = __webpack_public_path__ + "img/img13.e01cacd8.png";